export const FETCH_PRINTERS = "FETCH_PRINTERS"
export const ADD_PRINTER = "ADD_PRINTER"
export const EDIT_PRINTER = "EDIT_PRINTER"
export const DELETE_PRINTER = "DELETE_PRINTER"
export const ADD_POS_PRINTER = "ADD_POS_PRINTER"